<template>
  <div class="sideBarWrapper">
    <!-- <div class="sideBarItem" :class="focus === 'add' ? 'clickedBg' : ''">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <div class="sideBarLogo" v-bind="attrs" v-on="on">
            <PlusCircleIcon />
          </div>
        </template>

        <v-list>
          <div>text</div>
          <div>file</div>
        </v-list>
      </v-menu>
    </div> -->
    <div
      class="sideBarItem"
      :class="focus === 'start' ? 'clickedBg' : ''"
      @click="goPage('/start')"
    >
      <div class="sideBarLogo">
        <HomeIcon v-bind:clicked="focus === 'start'" />
      </div>
      <div class="sideBarName">{{$t('sideBar.start')}}</div>
    </div>
    <div
      class="sideBarItem"
      :class="
        focus === 'projects' || focus === 'textFolderDetails' ? 'clickedBg' : ''
      "
      @click="goPage('/projects')"
    >
      <div class="sideBarLogo">
        <TextIcon
          v-bind:clicked="focus === 'projects' || focus === 'textFolderDetails'"
        />
      </div>
      <div class="sideBarName">{{$t('sideBar.text')}}</div>
    </div>
    <!-- <div
      class="sideBarItem"
      :class="
        focus === 'books' || focus === 'fileFolderDetails' ? 'clickedBg' : ''
      "
      @click="redirectPage"
    >
      <div class="sideBarLogo">
        <FileIcon
          v-bind:clicked="focus === 'books' || focus === 'fileFolderDetails'"
        />
      </div>
      <div class="sideBarName">Файл</div>
    </div> -->
    <div
      class="sideBarItem"
      :class="focus === 'help' ? 'clickedBg' : ''"
      @click="goPage('/help')"
    >
      <div class="sideBarLogo">
        <QuestionIcon v-bind:clicked="focus === 'help'" />
      </div>
      <div class="sideBarName">{{$t('sideBar.help')}}</div>
    </div>
    <v-dialog v-model="warningDialog" max-width="400">
      <v-card class="infoDialogWrapper">
        <div style="display:flex;margin-bottom:20px">
          <v-icon class="infoIcon">mdi-information-outline</v-icon>
          <div>
            Та <span style="font-weight:500">{{ planName }}</span> эрхээр
            файлаас аудио хөрвүүлэх боломжгүй.
          </div>
        </div>

        <div style="display:flex;justify-content:flex-end;">
          <v-btn class="closeBtn" @click="warningDialog = false">хаах</v-btn>
          <v-btn class="activeBtn" text @click="goPlanPage('/plan')"
            >Эрх идэвхжүүлэх</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import FileIcon from "../components/icons/FileIcon";
import QuestionIcon from "../components/icons/QuestionIcon";
import HomeIcon from "../components/icons/HomeIcon";
import TextIcon from "../components/icons/TextIcon";
import { mapState } from "vuex";
export default {
  name: "SideBar",
  data: () => ({
    focus: "",
    warningDialog: false,
    planName: "",
  }),
  props: {
    onclick: Function,
  },
  watch: {
    $route(to) {
      this.focus = to.name;
    },
  },
  components: {
    // FileIcon,
    QuestionIcon,
    HomeIcon,
    TextIcon,
  },
  computed: {
    ...mapState(["customerPlan", "allPlan"]),
    getCurrentRoute: function() {
      return this.$router.currentRoute.name;
    },
    getPlanName() {
      let plan = this.allPlan.find(
        (plan) => plan.ID === this.customerPlan.PlanID
      );
      return plan.Name;
    },
  },
  mounted() {
    this.focus = this.getCurrentRoute.replace("/", "");
  },
  methods: {
    goPage(to) {
      if (to.replace("/", "") !== this.focus) {
        this.focus = to.replace("/", "");
        this.$router.push(to).catch((err) => {
          console.log(err);
        });
      }
    },
    goPlanPage(to) {
      this.warningDialog = false;
      this.$router.push(to).catch((err) => {
        console.log(err);
      });
    },
    redirectPage() {
      let plan = this.allPlan.find(
        (plan) => plan.ID === this.customerPlan.PlanID
      );
      let isFile = plan.Feature.privilege.split(",").indexOf("file");
      if (isFile != -1) {
        this.goPage("/books");
      } else {
        this.planName = plan.Name;

        this.warningDialog = true;
      }
    },
  },
};
</script>
<style scoped>
.sideBarWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5px;
  width: 76px;
  position: fixed;
  height: calc(100vh - 108px);
  border-right: 1px solid #e5e5e5;
  z-index: 1;
}

.sideBarItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 72px;
  height: 72px;
  border-radius: 15px;
  margin-bottom: 5px;
  transition: 0.3s ease-out;
}

.sideBarItem:hover {
  background-color: #e5e5e566;
  transition: 0.3s ease-out;
}

.sideBarName {
  font-size: 12px;
  color: #231f20;
  font-weight: 500;
  line-height: 14px;
}

.clickedBg {
  background-color: #e5e5e5 !important;
}

.infoDialogWrapper {
  display: flex;
  flex-direction: column;
  padding: 25px;
}

.infoIcon {
  color: #777ff6 !important;
  margin-right: 10px;
}

.activeBtn {
  display: flex;
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff !important;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 5px;
  height: 34px !important;
  width: auto;
}

.closeBtn {
  background-color: #ffffff !important;
  text-transform: initial;
  color: #767676 !important;
  border: 2px solid #e5e5e5;
  border-radius: 6px;
  box-shadow: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin-right: 10px;
  height: 34px !important;
  width: 64px !important;
}
</style>
